import type {ReactAction} from '@netx/core/bootstrap';
import {performAction} from '@netx/core/lib/utils';
import {faClipboardList} from '@fortawesome/pro-solid-svg-icons';
import {canViewAssetProjects} from '@netx/core-asset-project/enablers';
import {ProjectReviewsLabel} from '../locales';

export const projectReviewActionReviewsRouteIcon = faClipboardList;

/**
 * Route to project reviews
 * @param params
 * @returns Action
 */
export const projectReviewActionReviewsRoute = (
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'project-reviews-route',
	cb: () => performAction('projects:route'),
	enableTest: () => canViewAssetProjects(),
	icon: projectReviewActionReviewsRouteIcon,
	get label() {
		return ProjectReviewsLabel.ROUTE;
	},
	routeMatch: /^projects(\/?)/,
	...params,
});
